function initializePopupSlider() {
  let prevArrow = `<button class="slick-prev slick-arrow" style="transform:rotate(180deg)"><svg height="50" width="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" xml:space="preserve">
      <path fill="#333" d="M15.563 40.836a.997.997 0 0 0 1.414 0l15-15a1 1 0 0 0 0-1.414l-15-15a.999.999 0 1 0-1.414 1.414l14.293 14.293-14.293 14.293a1 1 0 0 0 0 1.414"/>
    </svg></button>`;

  let nextArrow = `<button class="slick-next slick-arrow"><svg height="50" width="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" xml:space="preserve">
      <path fill="#333" d="M15.563 40.836a.997.997 0 0 0 1.414 0l15-15a1 1 0 0 0 0-1.414l-15-15a.999.999 0 1 0-1.414 1.414l14.293 14.293-14.293 14.293a1 1 0 0 0 0 1.414"/>
    </svg></button>`;

  $("#ctm_poopup_box .prd_img_list").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    asNavFor: "#ctm_poopup_box .prd_img_list--thumbnail",
  });
  $("#ctm_poopup_box .prd_img_list--thumbnail").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: "#ctm_poopup_box .prd_img_list",
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: "30px",
    focusOnSelect: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  let targets = document.querySelectorAll(
    '.prd_form .product-form__submit[type="submit"]'
  );
  // let targets = document.querySelectorAll('.prd_container');
  let stickyATC = document.querySelector(".prd_footer");
  let getHeader;
  let prevVisibility = new Map();
  let debounceTimeout;

  if (window.innerWidth <= 767) {
    getHeader = document.getElementById("header");
  } else {
    getHeader = document.querySelector(".header.header_bar");
  }

  function getElementHeightWithMargins(el) {
    const style = window.getComputedStyle(el);

    const marginTop = parseFloat(style.marginTop);
    const marginBottom = parseFloat(style.marginBottom);

    const elementHeight = el.offsetHeight;
    const totalHeight = elementHeight + marginTop + marginBottom;
    return totalHeight;
  }

  function isElementInViewport(el, verticalOffset = 0) {
    let rect = el.getBoundingClientRect();

    return (
      rect.top >= verticalOffset &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function handleScroll() {
    targets.forEach((target) => {
      let headerHeight = getElementHeightWithMargins(getHeader);
      const inView = isElementInViewport(target, headerHeight);
      const wasInView = prevVisibility.get(target) || false;

      if (inView && !wasInView) {
        stickyATC.classList.remove("prd_footer--sticky_hide");
      } else if (!inView && wasInView) {
        stickyATC.classList.add("prd_footer--sticky_hide");
      }

      prevVisibility.set(target, inView);
    });
  }

  function debounceScroll() {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(handleScroll, 100); // Adjust the delay as needed
  }

  // Uncomment it if you want show Sticky Add to cart button on Scroll
  // window.addEventListener('scroll', debounceScroll);
  // handleScroll();

  if (stickyATC) {
      stickyATC.classList.contains("prd_footer--sticky_hide")
    ? ""
    : stickyATC.classList.add("prd_footer--sticky_hide");
  }
});

document.addEventListener("click", (e) => {
  if (e.target.closest(".pro_plus_btn")) {
    let item = e.target.closest(".pro_item_card--container");
    let prdFormData = item.querySelector(".popup_form_data").innerHTML;
    let prdDescData = item.querySelector(".popup_description_data")
      ? item.querySelector(".popup_description_data").innerHTML
      : "";
    let prdTitle = item.querySelector(".pro_title").innerHTML;
    let prdPrice = item.querySelector(".pro_price").innerHTML;
    let prdUrl = item.querySelector("a").getAttribute("href");
    let prdSlider = item.querySelector(".pro_img_sliers").innerHTML;

    let popup = document.getElementById("ctm_poopup_box");
    popup.querySelector(".popup_atc_form").innerHTML = prdFormData;
    popup.querySelector(".popup_prd_description").innerHTML = prdDescData;
    popup.querySelector(".pro_title").innerHTML = prdTitle;
    popup.querySelector(".pro_price").innerHTML = prdPrice;
    popup.querySelector(".popup_product_description a").setAttribute("href", prdUrl);
    popup.querySelector(".popup_galleery").innerHTML = prdSlider;

    initializePopupSlider();
    setTimeout(() => {
      $("#ctm_poopup_box .prd_img_list").slick("reinit");
      $("#ctm_poopup_box .prd_img_list--thumbnail").slick("reinit");
    }, 0);

    popup.style.display = "flex";
  }

  if (
    e.target.closest(".ctm_popup_exernal_space") ||
    e.target.closest(".popup_close_btn")
  ) {
    document.getElementById("ctm_poopup_box").style.display = "none";
  }
});

// const customFaqLinks = document.querySelectorAll(".multiblock--text_links li");

// customFaqLinks.forEach(function(item) {
//     item.addEventListener("click", function() {
//         const clickedText = item.textContent.trim();
//         console.log(clickedText);
//         const targetSection = Array.from(document.querySelectorAll(".multiblock--title-size h2 strong")).find(strong => strong.textContent.trim() === clickedText);

//         if (targetSection) {
//             const targetOffsetTop = targetSection.offsetTop;
//             const targetParent = targetSection.closest('.multiblock--title-size');
//             console.log('targetOffsetTop:', targetOffsetTop);
//             console.log('targetParent.offsetTop:', targetParent.offsetTop);
//             let offset = 100;
//             if(window.innerWidth < 767){ offset = 50; }
//             window.scrollTo({ top: targetOffsetTop - offset, behavior: 'smooth' });
//         } else {
//             console.log('No matching section found for:', clickedText);
//         }
//     });
// });

const customFaqLinks = document.querySelectorAll(".multiblock--text_links li");

customFaqLinks.forEach(function (item) {
  item.addEventListener("click", function () {
    const clickedText = item.textContent.trim();
    console.log(clickedText);
    const targetSection = Array.from(
      document.querySelectorAll(".multiblock--title-size h2 strong")
    ).find((strong) => strong.textContent.trim() === clickedText);

    if (targetSection) {
      const targetOffsetTop = targetSection.offsetTop;
      let offset = 100;
      if (window.innerWidth < 767) {
        offset = 50;
      }
      const targetPosition = targetOffsetTop - offset;

      // Custom smooth scroll function
      slowScrollTo(targetPosition, 2000); // 1000ms for 1 second
    } else {
      console.log("No matching section found for:", clickedText);
    }
  });
});

function slowScrollTo(targetY, duration) {
  const startY = window.pageYOffset;
  const distance = targetY - startY;
  let startTime = null;

  function animationStep(currentTime) {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startY, distance, duration);
    window.scrollTo(0, run);

    if (timeElapsed < duration) {
      requestAnimationFrame(animationStep);
    }
  }

  function ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(animationStep);
}

// Accordian Block

let accordianHead = document.querySelectorAll(".cus--contact_us .cus-accordian-click");
accordianHead.forEach((item) => {
  item.addEventListener("click", function () {item
      .closest(".cus--contact_us .multiblock--accordion")
      .querySelectorAll(".cus--contact_us .multiblock--accordion--content")
      .forEach((cont) => { cont.classList.remove("cus-accordian-hidden"); });
  });
});




// membership discount ---------------------

document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('memberId');
  const btn = document.querySelector('.vefimy-member');
  const disCode = document.getElementById('discount-for-members')?.value;

  input.addEventListener('input', () => {
    btn.classList.toggle('unactive', input.value.trim().length <= 4);
  });

  const message = document.querySelector('.member-verification p');

btn.addEventListener('click', async e => {
  e.preventDefault();
  const id = input.value.trim();
  if (btn.classList.contains('unactive') || btn.classList.contains('applied') || !/^\d{5,}$/.test(id)) return;

  btn.textContent = 'Checking...';

  try {
    const res = await fetch(`https://train.mantisx.com/nra-member-check/${id}/`);
    const data = await res.json();

    if (data.success) {
      input.disabled = true;
      btn.textContent = 'Applied';
      btn.classList.add('applied');
      
      showMessage("You're a verified NRA member. Discount applied.", 'green', true);

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              member_id: id
            }
          })
        });

        setTimeout(() => {
          window.location.reload();
        }, 2000);
        
      } catch (error) {
        showMessage("Update failed. Try again later.", 'red');
        console.error('Cart attribute update error:', error);
        return;
      }

      // if (disCode) setTimeout(() => {
      //   window.location.href = `https://mantisx.com/discount/${disCode}?redirect=/cart`;
      // }, 2000);
    } else {
      btn.textContent = 'Apply';
      showMessage("Member ID not recognized. Please try again.", 'red');
    }
  } catch {
    btn.textContent = 'Apply';
    showMessage("Something went wrong. Please try again later.", 'red');
  }
});

function showMessage(text, color , success = false) {
  message.textContent = text;
  message.style.display = 'block';
  message.style.color = color;

  if(!success){ setTimeout(() => { message.style.display = 'none' }, 2500)}
}

});


